var exports = {
  "Io": "pill__RjCSZg",
  "Kk": "icon__YZuaB6",
  "qV": "skeleton__4hgaTB",
};

module.exports = exports;
